
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 8H5a3 3 0 00-3 3v4a2.006 2.006 0 002 2h2v2a2.006 2.006 0 002 2h8a2.006 2.006 0 002-2v-2h2a2.006 2.006 0 002-2v-4a3 3 0 00-3-3zm-4 11H9a1 1 0 01-1-1v-4h8v4a1 1 0 01-1 1zm4-7a1 1 0 110-2 1 1 0 010 2zm-2-9H7a1 1 0 00-1 1v2a1 1 0 001 1h10a1 1 0 001-1V4a1 1 0 00-1-1z"}})])
          )
        }
      }
    